import { fill } from 'lodash';
import { DishFirstSegmentFilter, HierarchicalAvailableCuisineCategoryFragment } from 'src/gqlReactTypings.generated.d';
import { UseExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { CuisineButton, LoadingCuisineButton } from './CuisineFilterModal/CuisineButton';
import { useCuisineFilters } from './CuisineFilterModal/hooks';
import { CuisineCarousel, InlineContainer } from './CuisineFilterModal/styles';

interface CuisineFilterCarouselProps {
  allCuisineCategories?: HierarchicalAvailableCuisineCategoryFragment[];
  availableCuisineCategories: HierarchicalAvailableCuisineCategoryFragment[];
  filters: UseExploreUrl<DishFirstSegmentFilter>;
  loading: boolean;
  onFilterChange?: (filters: UseExploreUrl<DishFirstSegmentFilter>) => void;
}

export const CuisineFilterCarousel = ({
  allCuisineCategories,
  availableCuisineCategories,
  filters,
  loading,
  onFilterChange,
}: CuisineFilterCarouselProps) => {
  const {
    allCuisinesButtonProps,
    formattedCuisines,
    handleFilterChange,
    moreCuisineCategories,
    moreCuisinesButtonProps,
  } = useCuisineFilters({
    filters,
    availableCuisineCategories,
    allCuisineCategories,
    onFilterChange,
  });

  return (
    <InlineContainer>
      <CuisineCarousel scrollSnapOnSmallScreen isLightBackground>
        {loading ? (
          fill(new Array(16), null).map((_, index) => <LoadingCuisineButton key={index} />)
        ) : (
          <>
            <CuisineButton {...allCuisinesButtonProps} showInline />
            {formattedCuisines.map(({ cuisineFilter, isSelected, title }) => (
              <CuisineButton
                title={title}
                cuisineFilter={cuisineFilter}
                key={cuisineFilter}
                isSelected={isSelected}
                onChange={(cuisineFilter) => handleFilterChange(cuisineFilter, false)}
                showInline
              />
            ))}
            {moreCuisineCategories.length && <CuisineButton {...moreCuisinesButtonProps} />}
          </>
        )}
      </CuisineCarousel>
    </InlineContainer>
  );
};
